import React, { ReactNode } from "react";
import { Button } from "@tyrannosaurustech/ui";
import { ActionButton } from "./types";

interface ActionBarProps {
  actionButtonsConfig?: ActionButton[];
  actionRightButtons?: ActionButton[];
  actionRightAccessories?: ReactNode;
}

export const ActionBar: React.FC<ActionBarProps> = ({
  actionButtonsConfig,
  actionRightButtons,
  actionRightAccessories,
}) => {
  if (
    !actionButtonsConfig?.length &&
    !actionRightButtons?.length &&
    !actionRightAccessories
  ) {
    return null;
  }

  return (
    <div className="flex justify-between items-center gap-2 w-full bg-neutral-0 dark:bg-neutral-900 p-4 border-b border-neutral-300">
      <div className="flex items-center gap-2">
        {actionButtonsConfig?.map((button, idx) => {
          return (
            <Button
              key={idx}
              onClick={button.onClick}
              className={button.btnContainerClasses || ""}
              variant={(button.base as any) || "primary"}
              icon={button.icon as any}
              label={button.label}
              disabled={button.disabled}
              loading={button.loader}
            />
          );
        })}
      </div>
      <div className="flex gap-2 items-center">
        {actionRightButtons?.map((button, idx) => {
          return (
            <Button
              key={idx}
              onClick={button.onClick}
              className={button.btnContainerClasses || ""}
              variant={(button.base as any) || "primary"}
              icon={button.icon as any}
              label={button.label}
              disabled={button.disabled}
              loading={button.loader}
            />
          );
        })}
        {actionRightAccessories}
      </div>
    </div>
  );
};
